import { Component } from "@angular/core"
import { App, ViewController, NavController } from "ionic-angular"

import firebase from "firebase"

import { AppLocalStorage } from "../../services/app-local-storage"
import { ProfilePage } from "../../pages/profile"
import { HelpPage } from "../../pages/help"
import { LoginPage } from "../../pages/login"

@Component({
  selector: "user-popover",
  templateUrl: "index.html",
})
export class UserPopover {

  user: any = {}

  constructor(
    private viewCtrl: ViewController,
    private navCtrl: NavController,
    private appCtrl: App
  ) {}

  ionViewWillEnter() {

    this.user = AppLocalStorage.get("user")
  }

  navToProfile() {

    this.navCtrl.push(ProfilePage)
    this.viewCtrl.dismiss()
  }

  navToHelp() {

    this.navCtrl.push(HelpPage)
    this.viewCtrl.dismiss()
  }

  logout() {

    firebase.auth().signOut()

    AppLocalStorage.set("user", {})
    AppLocalStorage.set("userPicture", "")
    
    this.appCtrl.getRootNavs()[0].setRoot(LoginPage, {}, {animate: true, direction: "back"})
    this.viewCtrl.dismiss()    
  }

}



// WEBPACK FOOTER //
// ./src/components/user-popover/index.ts